<script>
  import {replace} from 'svelte-spa-router';
  
  import {link} from 'svelte-spa-router'
  import active from 'svelte-spa-router/active'

  const url = `/ianua/user/logout`;
  
  async function logout(){
    try {
      const res = await fetch(url, {
	method: 'GET',
      });
      if (res) {
	replace('/login');
      }
    } catch(err) {
      replace('/login');
    };
  };
  
</script>

<!-- Header -->
<header id="header">
  <nav id="nav">
    <ul>
      <li><a href="#/home" class="button fit small icon solid fa-home" use:link use:active={{path: '/home', className: 'primary'}}>Home</a></li>
      <!-- <li><a href="#/use" class="button fit small icon solid fa-user-cog" use:link use:active={{path: '/use', className: 'primary'}}>Utenti</a></li> -->
      <li><a href="#/gue" class="button fit small icon solid fa-user" use:link use:active={{path: '/gue', className: 'primary'}}>Ospiti</a></li>
      <!-- <li><a href="#/pag" class="button fit small icon solid fa-plus" use:link use:active={{path: '/pag', className: 'primary'}}>Nuova pagina</a></li>
	   <li><a href="#/pag" class="button fit small icon solid fa-edit" use:link use:active={{path: '/pag', className: 'primary'}}>Modifica pagina</a></li> -->
      <!-- <li><a href="#/log" class="button fit small icon solid fa-chart-line" use:link use:active={{path: '/log', className: 'primary'}}>Attività</a></li> -->
      <li><a href="#/con" class="button fit small icon solid fa-cog" use:link use:active={{path: '/con', className: 'primary'}}>Config</a></li>
      <li><a href="#" on:click|preventDefault="{logout}" class="button fit small icon solid fa-sign-out-alt">Uscita</a></li>
    </ul>
  </nav>
  
</header>

<style>
  #header {
    display: inline-block;
  }
</style>
